import { jsx as r } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { R as s, I as i, a as l } from "../../index-BYBK0P8Z.js";
import { c as a } from "../../cn-gv_k3DnN.js";
import { focusRing as b } from "../../utils/focus-ring.js";
const n = c(({ className: e, ...o }, d) => /* @__PURE__ */ r(
  s,
  {
    ref: d,
    className: a("gap-sp-2 grid", e),
    ...o
  }
));
n.displayName = "RadioCards";
const h = c(({ className: e, children: o, ...d }, t) => /* @__PURE__ */ r(
  i,
  {
    ref: t,
    className: a(
      b,
      // Base
      "px-sp-5 py-sp-4 group relative w-full rounded-lg bg-(--color-choicebox-bg) text-left antialiased border border-transparent transition",
      // Hover
      "hover:bg-(--color-choicebox-bg-hover)",
      // Checked
      "data-[state=checked]:border data-[state=checked]:border-(--color-choicebox-stroke-active)",
      "data-[state=checked]:bg-(--color-choicebox-bg-pressed)",
      "data-[state=checked]:text-(--color-choicebox-content-pressed)",
      // Disabled
      "data-[disabled]:border data-[disabled]:border-(--color-choicebox-stroke-disabled)",
      "data-[disabled]:bg-(--color-choicebox-bg-disabled)",
      "data-[disabled]:text-(--color-choicebox-content-disabled)",
      e
    ),
    ...d,
    children: o
  }
));
h.displayName = "RadioCardItem";
const g = c(({ className: e, ...o }, d) => /* @__PURE__ */ r(
  "div",
  {
    className: a(
      // Base
      "size-s-3 flex aspect-square items-center justify-center rounded-full border border-(--color-radio-stroke-unchecked)",
      // Checked
      "group-data-[state=checked]:border-(--color-radio-bg-checked)",
      "group-data-[state=checked]:bg-(--color-radio-bg-checked)",
      // Hover
      "group-hover:border-(--color-radio-stroke-unchecked-hover)",
      "group-hover:bg-(--color-radio-bg-unchecked-hover)",
      // Disabled
      "group-data-[disabled]:border-(--color-radio-stroke-unchecked-disabled)",
      "group-data-[disabled]:bg-(--color-radio-bg-unchecked-disabled)",
      e
    ),
    children: /* @__PURE__ */ r(
      l,
      {
        ref: d,
        className: "flex items-center justify-center",
        ...o,
        children: /* @__PURE__ */ r("div", { className: "size-s-1 rounded-full bg-(--color-radio-content-checked) group-data-[disabled]:bg-(--color-radio-content-checked-disabled)" })
      }
    )
  }
));
g.displayName = "RadioCardIndicator";
const x = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r("p", { className: a("text-body1-highlight", e), ...o }), R = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r("p", { className: a("text-body2", e), ...o });
export {
  R as RadioCardDescription,
  g as RadioCardIndicator,
  h as RadioCardItem,
  x as RadioCardTitle,
  n as RadioCards
};
